import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { useTranslation } from "react-i18next";
import { GeneralButton } from "../../common/ui/GeneralButton";

interface ConfirmTransactionDialogProps {
  open: boolean;
  title: string;
  message: string;
  onClose: () => void;
  onConfirm: () => void;
}

export default function ConfirmTransactionDialog({
  open,
  title,
  message,
  onClose,
  onConfirm,
}: ConfirmTransactionDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <GeneralButton
          appVariant="secondary"
          onClick={onClose}
        >
          {t("buttons.cancel")}
        </GeneralButton>

        <GeneralButton
          onClick={onConfirm}
          autoFocus
        >
          {t("buttons.confirm")}
        </GeneralButton>
      </DialogActions>
    </Dialog>
  );
}
